export default {
  filters: {
    convertToMajorBalance: function (balance) {
      return (balance / 100).toFixed(2)
    }
  }
}